const FORM_PORTAL_ID = '20940543';

const FORM_IDS = {
  CONTACT_US: '5770121b-a01e-476f-bcd3-66e5fa0d50e7',
  CONTACT_US_PARTNER: '7ac5b0a0-8a90-43f0-b4b1-13d372fc88b1',
  REQUEST_A_QUOTE: 'd6e44b02-0a42-48f8-954d-2a7cc313ca61',
  REQUEST_A_DEMO: 'b758959c-0ccf-49cb-acea-3eea6c63b377',
  SUBSCRIBE: 'cfbdde61-bb78-4780-a193-db195c7163cc',
};

export { FORM_PORTAL_ID, FORM_IDS };
